import { render, staticRenderFns } from "./UserAuthority.vue?vue&type=template&id=19b81611&scoped=true&"
import script from "./UserAuthority.vue?vue&type=script&lang=js&"
export * from "./UserAuthority.vue?vue&type=script&lang=js&"
import style0 from "./UserAuthority.vue?vue&type=style&index=0&id=19b81611&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b81611",
  null
  
)

export default component.exports